document.addEventListener("DOMContentLoaded", function () {
  // 폼 필드 참조
  const emailInput = document.getElementById("CustomerEmail");
  const passwordInput = document.getElementById("password");
  const submitButton = document.getElementById("submitButton");
  const validateButton = document.getElementById("validateButton");

  // 비밀번호 복구 관련 요소
  const recoverInput = document.getElementById("RecoverEmail");
  const recoverValidateButton = document.getElementById(
    "recoverValidateButton"
  );
  const recoverSubmitButton = document.getElementById("recoverSubmitButton");

  // 유효성 검사 메시지 요소
  const emailAlert = emailInput
    .closest(".c-input")
    .querySelector(".c-input__alert");
  const passwordAlert = passwordInput
    .closest(".c-input")
    .querySelector(".c-input__alert");

  // RecoverEmail 유효성 검사 메시지 요소
  const recoverAlert = recoverInput
    .closest(".c-input")
    .querySelector(".c-input__alert");

  // 유효성 검사 함수
  function validateForm() {
    let isValid = true;

    if (!emailInput.value.trim()) {
      emailAlert.style.display = "block";
      isValid = false;
    } else {
      emailAlert.style.display = "none";
    }

    if (!passwordInput.value.trim()) {
      passwordAlert.style.display = "block";
      isValid = false;
    } else {
      passwordAlert.style.display = "none";
    }

    if (!validateEmail()) {
      isValid = false;
    }

    return isValid;
  }

  // 이메일 유효성 검사 함수
  function validateEmail() {
    return checkEmailValidity(emailInput, emailAlert);
  }

  // RecoverEmail 유효성 검사 함수
  function validateRecoverEmail() {
    return checkEmailValidity(recoverInput, recoverAlert);
  }

  // 이메일 유효성 검증 공통 함수
  function checkEmailValidity(inputField, alertField) {
    const emailValue = inputField.value.trim();
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (emailValue === "") {
      alertField.style.display = "block";
      alertField.textContent = "Please enter your email.";
      return false;
    } else if (!emailPattern.test(emailValue)) {
      alertField.style.display = "block";
      alertField.textContent = "Please provide a valid email address.";
      return false;
    } else {
      alertField.style.display = "none";
      return true;
    }
  }

  // 일반 로그인 제출 버튼 클릭 시
  validateButton.addEventListener("click", function () {
    if (validateForm()) {
      submitButton.click();
    }
  });

  // Recover Email 제출 버튼 클릭 시
  recoverValidateButton.addEventListener("click", function () {
    if (validateRecoverEmail()) {
      recoverSubmitButton.click();
    }
  });

  // 입력 필드 값 변경 시 유효성 검사 수행
  emailInput.addEventListener("input", function () {
    validateEmail();
    toggleActiveClass(emailInput);
  });

  passwordInput.addEventListener("input", function () {
    if (passwordInput.value.trim() !== "") {
      passwordAlert.style.display = "none";
    }
    toggleActiveClass(passwordInput);
  });

  recoverInput.addEventListener("input", function () {
    validateRecoverEmail();
    toggleActiveClass(recoverInput);
  });

  // 입력값이 있으면 부모 div에 'c-input--active' 클래스 추가
  function toggleActiveClass(element) {
    const parentFieldInput = element.closest(".c-input");
    if (element.tagName === "INPUT") {
      if (element.value.trim() !== "") {
        parentFieldInput.classList.add("c-input--active");
      } else {
        parentFieldInput.classList.remove("c-input--active");
      }
    }
  }

  // 페이지 로드 시, 값이 있는 경우 'c-input--active' 클래스 추가
  toggleActiveClass(emailInput);
  toggleActiveClass(passwordInput);
  toggleActiveClass(recoverInput);
});
